/**
 * Created by yqdong on 2018/3/18.
 * qq: 1013501639
 * @author yqdong
 *
 */
import { mutations, actions, apis, getters } from '../constants'
import Store from '../Store'

export default function (ajax) {
  let store = new Store({
    state: {
      list: []
    },
    mutations: {
      [mutations.userGroup.setList] (state, list) {
        state.list = list
      }
    },
    actions: {
      [actions.userGroup.query] (context, force) {
        return new Promise((resolve, reject) => {
          if (context.state.ready.list && !force) {
            resolve()
            return
          }
          store.setReady(context, 'list', false)
          store.setError(context, 'list', false)
          ajax({
            url: apis.userGroup.query,
            useTransform: false,
            data: {
              appId: context.rootState.bizSys.currentApp.id,
              platform: 0,
              includeDefault: true,
              includeToday: true
            }
          })
            .then(res => {
              resolve();
              context.commit(mutations.userGroup.setList, res.data);
            })
            .catch(err => {
              store.setError(context, "list", true);
              reject(err);
            })
            .finally(() => {
              store.setReady(context, "list", true);
            });
        })
      }
    }
  })
  return store
}
